import { useAtomValue } from "jotai";
import type { FunctionComponent } from "react";
import { graphql, readInlineData } from "react-relay";

import { getResponsiveProps } from "scmp-app/components/header/features/helpers";
import type { HeaderFeatureCommonProps } from "scmp-app/components/header/features/types";
import { currentArticleAtom } from "scmp-app/lib/current-item";
import type { shareHeaderFeaturesContent$key } from "scmp-app/queries/__generated__/shareHeaderFeaturesContent.graphql";

import { StyledIconContainer, StyledShare } from "./styles";

export type HeaderFeaturesShareProps = HeaderFeatureCommonProps;

export const HeaderFeaturesShare: FunctionComponent<HeaderFeaturesShareProps> = ({ ...props }) => {
  const currentArticle = useAtomValue(currentArticleAtom);

  if (!currentArticle) return null;

  const content = readInlineData<shareHeaderFeaturesContent$key>(
    graphql`
      fragment shareHeaderFeaturesContent on Content @inline {
        ...shareArticle20Content
      }
    `,
    currentArticle,
  );

  return (
    <StyledIconContainer {...getResponsiveProps(props)}>
      <StyledShare position="article_header" reference={content} shouldSwap={props.shouldSwap} />
    </StyledIconContainer>
  );
};

HeaderFeaturesShare.displayName = "HeaderFeaturesShare";
